import React from "react";
import { useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import { ContractType } from "views/pages/subscription/component/ComponentWidget";
import Payment from "views/pages/subscription/component/payment/Payment";
import { useBasket } from "views/pages/subscription/hooks/useBasket";
import { FDetailOthers, FDetailPackage, FDetailPeriod, FDetailPrime, FDetailStartDate } from "../../../common/details";
import SubscriptionRequestBuilder from "api/request/SubscriptionRequestBuilder";


const FStepDetails=({ 
    avenantCode,
    fSubscriptionRequest,
    quotationResponse,
    packsSelected
})=> {

    const {goToPreviousStep, initStartDate, setInitStartDate, onFStartDateChange }=useBasket();
    
    useEffect(()=> {
        setInitStartDate({
            startDate: fSubscriptionRequest?.dateEffect,
            endDate: null,
            initialDate: fSubscriptionRequest?.dateEffect
        });
    }, [])

    const getGuaranties=()=> {
        const _guaranties = [];
        for(const packSelected of packsSelected) {

        }

        // if(_.size(packSelected?.customGuaranties) <= 0) return packSelected?.guaranties;
        // else {
        //     const customGuarantiesRef = (packSelected?.customGuaranties || []).map((customGuarantee)=> customGuarantee?.guaranteeRef);
        //     return (packSelected?.guaranties || [])?.filter((guarantee)=> customGuarantiesRef.includes(guarantee?.ref))
        // }
    }

    return(
        <React.Fragment>
            <div /* className="page-content" */>
                <Container fluid>                    
                    
                    <Row>
                        <Col className="col-xxl-9 order-xxl-0 order-first">
                            <Row>
                                <Col lg={4} md={6} >
                                    <FDetailPackage packTitle={"---"}/>
                                </Col>
                                <Col lg={4} md={6} >
                                    <FDetailPeriod perioTitle={quotationResponse?.period?.title} />
                                </Col>

                                <Col lg={4} md={6} >
                                    <FDetailStartDate 
                                        rangeDate={initStartDate} 
                                        onStartDateChange={onFStartDateChange} />
                                </Col>
                            </Row>
                            <FDetailOthers
                              autos= {fSubscriptionRequest?.autos}
                              guaranties={quotationResponse?.guaranties}
                              reductions={quotationResponse?.reductionGroups}
                              assistances={quotationResponse?.assistances}
                              assure={fSubscriptionRequest?.assure}
                               />
                        </Col>
                        <FDetailPrime 
                            primeTTC={fSubscriptionRequest?.primeTTC}
                            primeNette={fSubscriptionRequest?.primeNette}
                            extras={quotationResponse?.extras}
                            />
                        
                    </Row>
                    <Row>
                        <Col className="col-xxl-12">
                            <Payment 
                                backVisibility={true}
                                projectVisibility={true}
                                onlineVisiblity={true}
                                payload={SubscriptionRequestBuilder.fromThisFleet(avenantCode, fSubscriptionRequest)}
                                goBack={goToPreviousStep}
                                type={ContractType.FLOTTE} />
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default FStepDetails;